<template>
  <div class="homePage">
    <div class="img-wrapper"><div class="bgc-img"><table border="0" cellpadding="0" cellspacing="0" width="1080"><tbody><tr><td width="10" height="36"><img border="0" src="img/logo_10257.jpg" class="img1"></td><td width="770" height="120" align="right"><table border="0" cellpadding="0" cellspacing="0" width="100%"><tbody><tr><td width="100%" align="right"><p><br></p><p><img src="img/banner_10257.png" width="384" height="85" align="left" alt=""></p></td></tr><tr><td width="100%" height="50" align="right"></td></tr></tbody></table></td></tr></tbody></table></div></div>
    <div class="center-body">
      <a-row type="flex">
        <a-col :span="16">
          <!-- 采购意向与调查 -->
          <IntentionalSurvey />

          <!-- 招标大厅 -->
          <TenderingHall />

          <!-- 零星采购 -->
          <lxSelfBidding />
        </a-col>
        <a-col :span="8" style="padding-left: 16px;">
          <!-- 用户登录 -->
          <ToLogin />

          <!-- 系统通知 -->
          <SystemNotice />

          <!-- 操作说明 -->
          <OperatingInstructions />

          <!-- 常见问题 -->
          <AskedQuestion />
 
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import ToLogin from './components/toLogin.vue'
import SystemNotice from './components/SystemNotice.vue'
import OperatingInstructions from './components/OperatingInstructions.vue'
import AskedQuestion from './components/AskedQuestion.vue'
import TenderingHall from './components/TenderingHall'
import IntentionalSurvey from './components/IntentionalSurvey'
import lxSelfBidding from './components/lxSelfBidding'

export default {
  name: 'HomePage',
  components: { ToLogin, SystemNotice, OperatingInstructions, AskedQuestion, TenderingHall, IntentionalSurvey, lxSelfBidding },
  data() {
    return {
    }
  },
}
</script>

<style lang="less" scoped>
.homePage {
  background-color: #f6f6f6;
  .img-wrapper {
    text-align: center;
  }
  .bgc-img {
    background-color: white;
    width: 1080px; // 100%;
    margin: 0 auto 16px auto;
    .img1 {
      width: 600px;
      // padding-left: 100px;
      padding-left: 60px;
      padding-right: 35px;
    }
  }
  .center-body {
    margin: 0 auto;
    width: 1080px; // 1280px;
  }
}
</style>
